import React from "react";
import "./styles/SummaryByCountry.css";
import { connect } from "react-redux";
import * as actions from "../redux/actions/summaryByCountryActions";
import { Link } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

const SUMMARY_ITEMS = [
  { label: "sales", path: "/home/sales", countKey: "Sales" },
  { label: "rents", path: "/home/rents", countKey: "Rents" },
  { label: "exchanges", path: "/home/exchanges", countKey: "Exchanges" },
  { label: "donations", path: "/home/donations", countKey: "Donations" },
  { label: "auction", path: "/home/auction", countKey: "Auctions" },
];

class SummaryByCountry extends React.Component {
  componentDidMount() {
    if (!this.props.summaryLoaded) {
      this.fecthLoadSummary();
    }
  }

  fecthLoadSummary = async () => {
    try {
      await this.props
        .LoadSummaryByCountry(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { summary } = this.props;

    return (
      <div className="card summary-card">
        <div className="summary-card__header">
          <h4 className="summary-card__title">
            <Translate value="summary" />
          </h4>
        </div>
        <div className="summary-card__body">
          {SUMMARY_ITEMS.map(({ label, path, countKey }) => (
            <Link key={path} to={path} className="summary-row">
              <span className="summary-row__label">
                <Translate value={label} />
              </span>
              <span className="summary-row__count">{summary[countKey]}</span>
            </Link>
          ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    loading: reducer.summaryByCountry.loading,
    summary: reducer.summaryByCountry.item,
    summaryLoaded: reducer.summaryByCountry.loaded,
    error: reducer.summaryByCountry.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadSummaryByCountry: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryByCountry);
